(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerScrollCheck = document.getElementById('header-scroll-check');
      this.starSection = document.querySelectorAll(".header__logo--trigger")[0];
      this.image_sec_arr=[
        "image",
        "img",
        "slideshow",
        "carousel",
        "ed1bdea6c423"
      ];
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.starObsPrevY=0;
      this.starObsRatio=0;

      this.onLoadHandler= this.onLoad.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('load', this.onLoadHandler, false);

      this.createScrollObserver();
      this.createStarObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createScrollObserver() {
      let callback = this.onScrollObserver.bind(this);
      let observer = new IntersectionObserver(callback);
      
      observer.observe(this.headerScrollCheck);
    }

    createStarObserver(){
      let callback = this.onStarObserver.bind(this);
      let observer = new IntersectionObserver(callback,{
        threshold: [0.0, 0.2, 0.5, 0.6, 0.8, 1.0],
      });
      
      observer.observe(this.starSection);
    }

    onLoad(){
      const first_section = document.querySelectorAll("#MainContent > *")[0];

      if(first_section){
        if(this.checkBanner(first_section.id)){
           this.header.classList.add("header__hover-image");
        }
      }

      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    checkBanner(val){ 
      const res = this.image_sec_arr.filter(e=>val.match(e));
      return res.length>0? true : false;
    }

    onScrollObserver(entries,observer){
        this.headerBounds = entries[0].intersectionRect;

        if( entries[0].isIntersecting){
          this.header.classList.remove("is_scrolling");
          document.querySelector("body").classList.remove("header-is_scrolling");
        }
        else{
          this.header.classList.add("is_scrolling");
          document.querySelector("body").classList.add("header-is_scrolling");
        }

        //console.log("Scrolling", entries, observer)
        //observer.disconnect();
    }

    onStarObserver(entries,observer){
        const currentY = entries[0].boundingClientRect.y;
        const currentRatio = entries[0].intersectionRatio;
        const isIntersecting = entries[0].isIntersecting;

        if (currentY < this.starObsPrevY) {
          if (currentRatio > this.starObsRatio && isIntersecting) {
            console.log("Scrolling down enter");
          } else {
            console.log("Scrolling down leave here we should switch to star in header");
            this.header.classList.add("header__star-logo");
          }
        } else if (currentY > this.starObsPrevY && isIntersecting) {
          if (currentRatio < this.starObsRatio) {
            console.log("Scrolling up leave");
          } else {
            console.log("Scrolling up enter get Old logo");
            this.header.classList.remove("header__star-logo");
          }
        }

        this.starObsPrevY = currentY;
        this.starObsRatio = currentRatio;

        /*console.log("Scrolling star", entries, observer, {
          starObsPrev:this.starObsPrev,
          starObsRatio:this.starObsRatio,
          currentY,
          currentRatio,
          isIntersecting
        })*/
        //observer.disconnect();
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
